import type { ReportStatus } from '@/types/reports';

const START_SEND_STATUSES = new Set<ReportStatus>(['awaiting_send']);

const RESEND_STATUSES = new Set<ReportStatus>(['sent', 'send_failed']);

export function normalizeReportStatus(value: unknown): ReportStatus {
  if (typeof value !== 'string') {
    return 'draft';
  }

  const normalized = value.trim().toLowerCase().replace(/-/g, '_');

  if (normalized === 'awaiting_send') return 'awaiting_send';
  if (normalized === 'finished' || normalized === 'finalizado') return 'finished';
  if (normalized === 'draft') return 'draft';
  if (normalized === 'sending') return 'sending';
  if (normalized === 'sent') return 'sent';
  if (normalized === 'send_failed') return 'send_failed';
  return 'draft';
}

export function canStartReportSend(status: ReportStatus): boolean {
  return START_SEND_STATUSES.has(status);
}

export function canResendReport(status: ReportStatus): boolean {
  return RESEND_STATUSES.has(status);
}

export function canSendReport(status: ReportStatus): boolean {
  return canStartReportSend(status) || canResendReport(status);
}

export function getReportStatusLabel(status?: ReportStatus): string {
  if (status === 'awaiting_send') return 'Aguardando envio';
  if (status === 'sending') return 'Enviando';
  if (status === 'sent') return 'Enviado';
  if (status === 'send_failed') return 'Falha no envio';
  if (status === 'draft' || status === 'finished') return 'Em rascunho';
  return 'Aguardando envio';
}

export const REPORT_STATUS_AWAITING_SEND = 'AWAITING_SEND' as const;

export const REPORT_STATUS_SEND_FAILED = 'SEND_FAILED' as const;

export const REPORT_STATUS_SENT = 'SENT' as const;

export const REPORT_STATUS_LABELS: Record<ReportStatus, string> = {
  draft: 'Em rascunho',
  finished: 'Em rascunho',
  awaiting_send: 'Aguardando envio',
  sending: 'Enviando',
  sent: 'Enviado',
  send_failed: 'Falha no envio',
};
